export default __webpack_public_path__ + "static/foursource-logo-grey-22338a962e9b5c25aca800607ace77fc.svg";